import { useScroll, motion, useTransform } from "framer-motion";
import { useContext, useRef } from "react";
import styled from "styled-components";
import ContactForm from "./ContactForm.js";
import InputCard from "../../../helperComponents/InputCard.js";
import Context from "../../../../Context.js";
import SquareDecoration from "./SquareDecoration.js";

let canvasDimension = 1000;

const Canvas = styled.canvas`
  margin-left: 0;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 150px;
  gap: 50px;

  @media (max-width: 900px) {
    width: 90vw;
  }

  /* background-image: url("/dumbbells.jpg"); */
`;

let maxFrames = 40;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  justify-content: center;
  gap: 40px;
  align-items: center;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const Img = styled.img`
  width: 300px;
  height: auto;
  object-fit: contain;

  @media (max-width: 900px) {
    display: none;
  }
`;

const Label = styled.h1`
  font-size: 35px;
  font-weight: 600;
  font-family: "Montserrat", serif;
  color: #030b23ff;
  text-align: center;
`;

const Layer = styled(motion.div)``;

export default function ContactUs() {
  const { mainScrollRef, isMobile } = useContext(Context);
  const { scrollY } = useScroll({ container: mainScrollRef });

  const x1 = useTransform(scrollY, [1200, 1800], [-1000, 0]);
  const x2 = useTransform(scrollY, [1200, 1800], [1000, 0]);

  return (
    <Container id="contact-section">
      <Label>Contact Us</Label>

      <Row>
        {!isMobile && (
          <Layer style={{ x: x1 }}>
            <SquareDecoration />
          </Layer>
        )}

        <Layer style={{ x: x2 }}>
          <ContactForm />
        </Layer>
      </Row>
    </Container>
  );
}
